'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('aeivedlysCtrl', ['$scope', '$http', '$q', '$log', 'ajaxSearch', function ($scope, $http, $q, $log, ajaxSearch) {
	$scope.dataUrl = aeivedlysData.dataUrl;
	$scope.objectSearched = false;
	$scope.text_col = '';
	$scope.objekto_numeris = aeivedlysData.objectNo;
	$scope.item = {
		LOG: '',
		IGG: '',
		LGG: ''
	};
	$scope.displayStatus = 0;

	$scope.findUrl = aeivedlysData.findUrl;
	$scope.postUrl = aeivedlysData.submitUrl; // vieninga registracijos forma (ESOEW4-1598): PDF pasiūlymas ir/ar prenumerata
	$scope.isFeatured = false; // 1 varnelė (paskaičiavimas) galima tik is_featured objektams
	$scope.canSubscribe = false; // 2 varnelė (pranešimas) galima tik „1 kW" objektams (3.5.1)
	$scope.loading = false; // adreso paieška
	$scope.submitting = false; // registracijos POST vykdomas – laukai išjungti
	$scope.submited = false;
	$scope.responseFalse = false;
	$scope.messages = [];
	$scope.addresses = [];
	$scope.showSuggest = false;

	$scope.emailPattern = /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,6}$/;
	$scope.housePattern = /^[0-9]/;

	function getDefaultData() {
		return {
			obj_numeris: '',
			email: '',
			address: '',
			address_id: null,
			want_offer: false, // „Noriu gauti paskaičiavimą…" – adresas + el. paštas
			want_subscription: false // „Noriu gauti informaciją…" – tik el. paštas
		};
	}
	$scope.formData = getDefaultData();

	// Pradinė būsena: be objekto duomenų, be formos, be pranešimų.
	function resetState() {
		$scope.submited = false;
		$scope.responseFalse = false;
		$scope.objectSearched = false;
		$scope.clearAddressSugggests();
		$scope.show_bad_searches = false;
		$scope.formData = getDefaultData();
		$scope.text_col = '';
		$scope.error_message = '';
		$scope.isFeatured = false;
		$scope.canSubscribe = false;
		$scope.messages = [];
		$scope.item = {
			LOG: '',
			IGG: '',
			LGG: ''
		};
	}

	// „Grįžti į pradžią" po sėkmės pranešimo
	$scope.backToStart = function () {
		resetState();
		$scope.objekto_numeris = '';
	};

	$scope.searchObjectNr = function () {
		if (!$scope.objekto_numeris || $scope.checking_nr) {
			return;
		}
		resetState();
		$scope.checking_nr = true;
		if ($scope.dataUrl !== '' && $scope.objekto_numeris !== '') {
			$http({
				method: 'POST',
				url: $scope.dataUrl,
				data: {
					nr: $scope.objekto_numeris
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.canSubscribe = !!response.data.can_subscribe;
					$scope.isFeatured = !!response.data.is_featured;
					$scope.formData.obj_numeris = $scope.objekto_numeris;
					$scope.objectSearched = true; // ir featured objektui be text_col eilučių
					if(response.data.data){
						for (let list of response.data.data) {
							$scope.objectSearched = true;
							if (list.text_col !== '' && $scope.text_col === '') {
								$scope.text_col = list.text_col;
							}
							if (typeof (list.tipas) !== 'undefined') {
								if (list.tipas === 'LOG') {
									$scope.item.LOG = list.galia;
								}
								if (list.tipas === 'IGG') {
									$scope.item.IGG = list.galia;
								}
								if (list.tipas === 'LGG') {
									$scope.item.LGG = list.galia;
								}
							}
						}
					}
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	$scope.findAddress = function () {
		$scope.formData.address_id = null;
		if ($scope.findUrl !== '' && $scope.formData.address != '') {

			$scope.loading = true;
			$scope.show_bad_searches = false;
			$scope.clearAddressSugggests();

			ajaxSearch.search($scope.findUrl, {address: $scope.formData.address}).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
						$scope.show_bad_searches = false;
					} else {
						$scope.addresses = [];
						$scope.messages = response.messages;
						if ($scope.formData.address != '' && $scope.formData.address.length >= $scope.bad_address_length) {
							$scope.show_bad_searches = true;
						}
					}
					$scope.loading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
		}
	};

	$scope.setAddress = function (address) {
		$scope.formData.address_id = address._source.adr_id;
		$scope.formData.address = address._source.adr_sudetinis_adresas;
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
		$scope.messages = [];
	};

	// Laukai matomi iš karto, bet disabled: adresas atsirakina su 1 varnele, el. paštas – su bet kuria.
	$scope.anyOptionChecked = function () {
		return !!($scope.formData.want_offer || $scope.formData.want_subscription);
	};

	// Pažymėtas bent vienas variantas ir užpildyti jo laukai (1 – adresas + el. paštas, 2 – el. paštas).
	function isComplete() {
		var data = $scope.formData;
		if (!$scope.anyOptionChecked()) {
			return false;
		}
		if (data.want_offer && !data.address) {
			return false;
		}
		return !!data.email;
	}

	$scope.canSubmit = function (form) {
		return isComplete() && !form.$invalid && !form.$submitted && !$scope.submitting;
	};

	// Vieningas registracijos payload'as – tą patį gaus ir būsimas backend'o endpoint'as.
	function buildPayload() {
		var data = $scope.formData;
		var payload = {
			obj_numeris: $scope.objekto_numeris,
			email: data.email,
			want_offer: !!data.want_offer,
			want_subscription: !!data.want_subscription
		};
		if (data.want_offer) {
			payload.address = data.address;
			payload.address_id = data.address_id;
		}
		return payload;
	}

	// reCAPTCHA v3 tokenas (kai recaptcha įjungta), kitaip null.
	function getCaptchaToken(action) {
		var deferred = $q.defer();
		if (typeof aeivedlysData.recaptcha === 'undefined') {
			deferred.resolve(null);
			return deferred.promise;
		}
		grecaptcha.ready(function () {
			grecaptcha.execute(aeivedlysData.recaptcha.siteKey, {action: action}).then(function (token) {
				deferred.resolve(token);
			}, function (error) {
				deferred.reject(error);
			});
		});
		return deferred.promise;
	}

	function post(url, payload, action) {
		return getCaptchaToken(action).then(function (token) {
			var data = angular.copy(payload);
			if (token !== null) {
				data[aeivedlysData.recaptcha.field] = token;
			}
			return $http({
				method: 'POST',
				url: url,
				data: data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			});
		});
	}

	// Vienas POST į submit: backend'as pagal want_offer / want_subscription atlieka vieną ar abu veiksmus
	// ir grąžina {success, messages}.
	function postRegistration(payload) {
		return post($scope.postUrl, payload, 'submit').then(function (response) {
			var data = response.data || {};
			return {
				success: !!data.success,
				messages: angular.isArray(data.messages) ? data.messages : []
			};
		});
	}

	$scope.submitForm = function (form) {
		// ng-submit metu form.$submitted gali būti jau true, todėl tikrinama be jo.
		if (!isComplete() || form.$invalid || $scope.submitting) {
			form.$submitted = false;
			return;
		}
		$scope.submitting = true;
		$scope.messages = [];
		$scope.responseFalse = false;
		postRegistration(buildPayload()).then(function (result) {
			if (result.success) {
				$scope.submited = true;
				form.$setPristine();
				form.$setUntouched();
			} else {
				$scope.responseFalse = true;
			}
			$scope.messages = result.messages;
		}, function (error) {
			$log.error(error);
			$scope.responseFalse = true;
		}).then(function () {
			form.$submitted = false;
			$scope.submitting = false;
		});
	};

	if($scope.objekto_numeris != ''){
		$scope.searchObjectNr();
	}
}]);
